import { api } from "./api";

export const superUserPermissionListApi = (params) => {
  return api.get(`/manufacturer/super-user/permission-list`, params);
};

export const superUserListApi = (params) => {
  return api.get(`/manufacturer/super-user/list`, { params });
};

export const superUserCreateApi = (params) => {
  return api.post(`/manufacturer/super-user/create`, JSON.stringify(params));
};

export const superUserEditApi = (params) => {
  return api.post(`/manufacturer/super-user/edit`, JSON.stringify(params));
};

export const superUserViewApi = (params) => {
  return api.get(`/manufacturer/super-user/view`, { params });
};

export const sueprUserDeleteApi = (params) => {
  return api.delete(`/manufacturer/super-user/delete`, { data: params });
};

export const superUserVersionListApi = (params) => {
  return api.get(`manufacturer/super-user/version-list`, {
    params: params,
  });
};
export const superUserVersionDetailApi = (params) => {
  return api.get(`/manufacturer/super-user/version-view`, { params });
};
export const permissionListApi = (params) => {
  return api.get(`/manufacturer/super-user/permission-list`);
};


export const superUserRoleListApi = (params) => {
  return api.get(`/manufacturer/role/list`, { params });
};

export const superUserRoleCreateApi = (params) => {
  return api.post(`/manufacturer/role/create`, JSON.stringify(params));
};

export const superUserRoleEditApi = (params) => {
  return api.post(`/manufacturer/role/edit`, JSON.stringify(params));
};

export const superUserRoleViewApi = (params) => {
  return api.get(`/manufacturer/role/view`, { params });
};

export const superUserRoleDeleteApi = (params) => {
  return api.delete(`/manufacturer/role/delete`, { data: params });
};

export const superUserRoleVersionListApi = (params) => {
  return api.get(`/manufacturer/role/version-list`, { params: params });
};
export const superUserRoleVersionDetailApi = (params) => {
  return api.get(`/manufacturer/role/version-view`, { params });
};
export const permissionRoleListApi = (params) => {
  return api.get(`/manufacturer/role/permission-list`);
};
export const roleListApi = (params) => {
  return api.get(`/manufacturer/super-user/roles-list`);
};
